{
  "de": {
    "company": {
      "actions": {
        "changeCompany": "Organisation ändern",
        "searchCompany": "Organisation durchsuchen"
      },
      "attributes": {
        "address": "Adresse",
        "email_address": "E-Mail",
        "iban": "IBAN",
        "language": "Sprache",
        "name": "Organisationsname",
        "phone": "Telefon",
        "subdomain": "Subdomain",
        "vat": "USt-IdNr."
      },
      "labels": {
        "company": "Organisation",
        "contact": "Kontakt",
        "contacts": "Kontakte",
        "language": "Dies ist die Standardsprache der Organisation für Ihre Login-Seite, Kunden und Teammitglieder.",
        "or": "ODER"
      },
      "validation": {
        "contactAlreadyExist": "Kontakt existiert bereits. Bitte wählen Sie aus dem Dropdown-Menü aus.",
        "mustBeEmailAddress": "Gültige E-Mail-Adresse erforderlich",
        "needName": "Name ist erforderlich"
      }
    }
  }
}
